(function () {
  'use strict';

  /* @ngdoc object
   * @name acUtilizationReport
   * @description
   *
   */
  angular
    .module('acUtilizationReport', [
      'ui.router'
    ]);
}());
